import { registerMockAPI } from '~/mocks/mockApis';

import { useAPI, useAsyncHandler } from '~/hooks/common';

import { API_ENDPOINT } from '~/constants';

import type { TypeGetExchangeOrdersExistenceParams } from '~/types/claim.types';
import type { TypeErrorResponseData } from '~/types/common.types';

/**
 * [반품교환관리] 교환 신청 여부 조회 api 요청 훅
 */
const useGetExchangeOrdersExistence = () => {
  const { runAsync } = useAsyncHandler();

  const getExchangeOrdersExistence = useAPI<TypeGetExchangeOrdersExistenceParams, boolean & { data: unknown }>({
    endpoint: API_ENDPOINT.CLAIM.GET_EXCHANGE_ORDERS_EXISTENCE,
    method: 'get',
  });

  const requestExchangeOrdersExistence = async (
    params: TypeGetExchangeOrdersExistenceParams,
    {
      onSuccess,
      onError,
    }: {
      onSuccess?: (data: boolean) => void;
      onError?: (error: TypeErrorResponseData['error']) => void;
    }
  ) => {
    runAsync(() => getExchangeOrdersExistence({ params }), {
      onSuccess: (data) => onSuccess?.(data),
      onError: (error: TypeErrorResponseData['error']) => onError?.(error),
    });
  };

  return { requestExchangeOrdersExistence };
};

export default useGetExchangeOrdersExistence;

// 화면이 응답 본문을 그대로 참/거짓으로 읽어, `{ data: false }` 가 아니라 `false` 자체를 내려야 확인 다이얼로그를 건너뛴다.
registerMockAPI<boolean>({
  method: 'get',
  endpoint: '/api-oms/exchange-orders/existence',
  label: '반품교환/교환신청등록/신청여부',
  scenarios: [
    { name: '신청 이력 없음', response: false },
    { name: '신청 이력 있음', response: true },
  ],
});
